import {
  PAYROLL_ROSTER_FIELD_TYPE,
  ROSTER_FILTER_KIND,
  type PayrollRosterFieldFilters,
  type PayrollRosterField,
  type RosterFieldFilter,
  type RosterFilterKind,
} from "@/payroll/roster/types";

export const ROSTER_NO_VALUE_LABEL = "No value";

export const rosterFilterKind = (
  field: PayrollRosterField,
): RosterFilterKind => {
  switch (field.field_type) {
    case PAYROLL_ROSTER_FIELD_TYPE.boolean:
      return ROSTER_FILTER_KIND.boolean;
    case PAYROLL_ROSTER_FIELD_TYPE.number:
      return ROSTER_FILTER_KIND.range;
    case PAYROLL_ROSTER_FIELD_TYPE.text:
      return ROSTER_FILTER_KIND.text;
    default:
      return ROSTER_FILTER_KIND.options;
  }
};

export const emptyRosterFilter = (
  field: PayrollRosterField,
): RosterFieldFilter => {
  switch (rosterFilterKind(field)) {
    case ROSTER_FILTER_KIND.boolean:
      return {
        kind: ROSTER_FILTER_KIND.boolean,
        values: [],
        includeBlank: false,
      };
    case ROSTER_FILTER_KIND.range:
      return {
        kind: ROSTER_FILTER_KIND.range,
        min: "",
        max: "",
        includeBlank: false,
      };
    case ROSTER_FILTER_KIND.text:
      return { kind: ROSTER_FILTER_KIND.text, query: "", includeBlank: false };
    default:
      return {
        kind: ROSTER_FILTER_KIND.options,
        values: [],
        includeBlank: false,
      };
  }
};

export const parseRosterRangeBound = (bound: string): number | null => {
  const trimmed = bound.trim();
  if (!trimmed) return null;
  const numeric = Number(trimmed);
  return Number.isFinite(numeric) ? numeric : null;
};

export const isRosterFilterActive = (filter: RosterFieldFilter): boolean => {
  if (filter.includeBlank) return true;

  switch (filter.kind) {
    case ROSTER_FILTER_KIND.options:
    case ROSTER_FILTER_KIND.boolean:
      return filter.values.length > 0;
    case ROSTER_FILTER_KIND.range:
      return (
        parseRosterRangeBound(filter.min) !== null ||
        parseRosterRangeBound(filter.max) !== null
      );
    case ROSTER_FILTER_KIND.text:
      return filter.query.trim().length > 0;
  }
};

export const rosterFilterHasInput = (filter: RosterFieldFilter): boolean => {
  if (isRosterFilterActive(filter)) return true;

  switch (filter.kind) {
    case ROSTER_FILTER_KIND.range:
      return filter.min.length > 0 || filter.max.length > 0;
    case ROSTER_FILTER_KIND.text:
      return filter.query.length > 0;
    default:
      return false;
  }
};

export const activeRosterFilterCount = (
  filters: PayrollRosterFieldFilters,
): number =>
  Object.values(filters).filter((filter) => isRosterFilterActive(filter))
    .length;

export const hasActiveRosterFilter = (
  filters: PayrollRosterFieldFilters,
  fieldKey: string,
): boolean => {
  const filter = filters[fieldKey];
  return filter != null && isRosterFilterActive(filter);
};
